import { useCallback, useRef, useState } from 'react';

const debounce = (fn, ms) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
};

export const useContainerSize = (delay = 100) => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const observerRef = useRef(null);

  const ref = useCallback(
    (node) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }

      if (!node) return;

      const { width, height } = node.getBoundingClientRect();
      setSize({ width, height });

      const debouncedSet = debounce(({ width, height }) => {
        setSize({ width, height });
      }, delay);

      const observer = new ResizeObserver(([entry]) => {
        debouncedSet(entry.contentRect);
      });

      observer.observe(node);
      observerRef.current = observer;
    },
    [delay],
  );

  return { ref, size };
};
